import { Check, Copy } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "components/ui/button";
import { cn } from "lib/utils";
import { USAGE_LIMITS_I18N } from "features/usage-config/constants/usage-meters";
import { useCopyToClipboard } from "features/usage-config/hooks/use-copy-to-clipboard";

const T = USAGE_LIMITS_I18N;

/** Copies one key. Works read-only: an inherited key is the one most often pasted elsewhere. */
export const CopyKeyButton = ({
  value,
  label,
  className,
}: {
  value: string;
  label: string;
  className?: string;
}) => {
  const { t } = useTranslation();
  const { isCopying, copy } = useCopyToClipboard();

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className={cn("h-7 w-7", className)}
      disabled={!value || isCopying}
      aria-label={isCopying ? t(T.KEY_COPIED) : label}
      title={isCopying ? t(T.KEY_COPIED) : label}
      onClick={() => copy(value)}
    >
      {isCopying ? (
        <Check className="h-3.5 w-3.5 text-green-600" />
      ) : (
        <Copy className="h-3.5 w-3.5 text-muted-foreground" />
      )}
    </Button>
  );
};
